export enum PartnerIdEnum {
  BSI_ID = '6736394'
}